/**
 * 系统配置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationParameterService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 系统配置接口
  /**
   * 根据configKey查询系统配置所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getAppListByKey(param) {
    const url = this.prefix + 'applicationConfig/queryApplicationConfigSonsByConfigKey';
    return this.http.Post(url, param);
  }

  /**
   * 查询系统配置所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getAppList(param) {
    const url = this.prefix + 'applicationConfig/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查询系统配置单个信息
   * @param param
   * @returns {Observable<any>}
   */
  getAppConfig(param) {
    const url = this.prefix + 'applicationConfig/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新系统配置信息
   * @param param
   * @returns {Observable<any>}
   */
  updateAppConfig(param) {
    const url = this.prefix + 'applicationConfig/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除系统配置单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteAppConfig(param) {
    const url = this.prefix + 'applicationConfig/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加系统配置单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveAppConfig(param) {
    const url = this.prefix + 'applicationConfig/save';
    return this.http.Post(url, param);
  }

  //#endregion


}
